module.exports = __webpack_public_path__ + "static/media/map.fdc862e0.jpg";